var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const BOX_SELECTOR = /&?(xywh=)?(pixel:|percent:|pct:)?([0-9]+(?:\.[0-9]+)?),([0-9]+(?:\.[0-9]+)?),([0-9]+(?:\.[0-9]+)?),([0-9]+(?:\.[0-9]+)?)/;
const TEMPORAL_SELECTOR = /&?(t=)(npt:)?([0-9]+(.[0-9]+)?)?(,([0-9]+(.[0-9]+)?))?/;
function parseSelector(source) {
  if (Array.isArray(source)) {
    return source.reduce((data, nextSource) => {
      const { selector, selectors } = parseSelector(nextSource);
      if (selector) {
        if (!data.selector) {
          data.selector = selector;
        }
        data.selectors.push(...selectors);
      }
      return data;
    }, {
      selector: null,
      selectors: []
    });
  }
  if (!source) {
    return {
      selector: null,
      selectors: []
    };
  }
  if (typeof source === "string") {
    const [id, fragment] = source.split("#");
    if (!fragment) {
      return {
        selector: null,
        selectors: []
      };
    }
    return parseSelector({ type: "FragmentSelector", value: fragment });
  }
  if (source.type === "PointSelector" && (source.t || source.t === 0)) {
    const selector = {
      type: "TemporalSelector",
      temporal: {
        startTime: source.t
      }
    };
    return {
      selector,
      selectors: [selector]
    };
  }
  if (source.type === "FragmentSelector") {
    const matchBoxSelector = BOX_SELECTOR.exec(source.value);
    if (matchBoxSelector) {
      const selector = {
        type: "BoxSelector",
        spatial: {
          unit: matchBoxSelector[2] === "percent:" || matchBoxSelector[2] === "pct:" ? "percent" : "pixel",
          x: parseFloat(matchBoxSelector[3]),
          y: parseFloat(matchBoxSelector[4]),
          width: parseFloat(matchBoxSelector[5]),
          height: parseFloat(matchBoxSelector[6])
        }
      };
      return {
        selector,
        selectors: [selector]
      };
    }
    const matchTimeSelector = source.value.match(TEMPORAL_SELECTOR);
    if (matchTimeSelector) {
      const selector = {
        type: "TemporalSelector",
        temporal: {
          startTime: matchTimeSelector[4] ? parseFloat(matchTimeSelector[4]) : 0,
          endTime: matchTimeSelector[7] ? parseFloat(matchTimeSelector[7]) : void 0
        }
      };
      return {
        selector,
        selectors: [selector]
      };
    }
    return {
      selector: null,
      selectors: []
    };
  }
  return {
    selector: null,
    selectors: []
  };
}
function expandTarget(target, options = {}) {
  if (Array.isArray(target)) {
    return expandTarget(target[0]);
  }
  if (typeof target === "string") {
    const [id, fragment] = target.split("#");
    if (!fragment) {
      return {
        type: "SpecificResource",
        source: { id, type: options.typeMap && options.typeMap[id] || "Unknown" },
        selector: null,
        selectors: []
      };
    }
    return expandTarget({
      type: "SpecificResource",
      source: { id, type: "Unknown" },
      selector: {
        type: "FragmentSelector",
        value: fragment
      }
    });
  }
  if (target.type === "Choice" || target.type === "List" || target.type === "Composite" || target.type === "Independents") {
    return expandTarget(target.items[0]);
  }
  if (target.type === "SpecificResource") {
    if (target.source.type === "Canvas" && target.source.partOf && typeof target.source.partOf === "string") {
      target.source.partOf = [
        {
          id: target.source.partOf,
          type: "Manifest"
        }
      ];
    }
    const { selector, selectors } = target.selector ? parseSelector(target.selector) : { selector: null, selectors: [] };
    return {
      type: "SpecificResource",
      source: target.source,
      selector,
      selectors
    };
  }
  if (target.id) {
    if (target.type === "Canvas" && target.partOf && typeof target.partOf === "string") {
      target.partOf = [
        {
          id: target.partOf,
          type: "Manifest"
        }
      ];
    }
    const [id, fragment] = target.id.split("#");
    if (!fragment) {
      return {
        type: "SpecificResource",
        source: __spreadProps(__spreadValues({}, target), {
          id
        }),
        selector: null,
        selectors: []
      };
    }
    return expandTarget({
      type: "SpecificResource",
      source: __spreadProps(__spreadValues({}, target), {
        id
      }),
      selector: {
        type: "FragmentSelector",
        value: fragment
      }
    });
  }
  return {
    type: "SpecificResource",
    source: target,
    selector: null,
    selectors: []
  };
}
export { expandTarget, parseSelector };
//# sourceMappingURL=annotation-targets.mjs.map
